"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BoolCellRenderer = (params) => {
    const value = Boolean(Number(params.value));
    if (value) {
        return `<div class="text-center text-gray-900">
            <span title="true" class="ag-icon content-icon ag-icon-tick" />
        </div>`;
    }
    return ``;
};
exports.default = BoolCellRenderer;
